import {combineReducers} from 'redux';
import {combineEpics} from 'redux-observable';
import {catchError} from 'rxjs/operators';

import * as AppEpics from './app/app.epics';
import * as ReportEpics from './reports/reports.epics';
import * as AccountsEpics from './accounts/accounts.epics';
import * as UserEpics from './user/user.epics';
import * as TableColumnsEpics from './table-columns/table-columns.epic';
import * as HistoryEpics from './history/history.epic';
import * as SearchEpics from './search/search.epic';
import * as SecurityEpics from './security/security.epic';
import * as FavouriteEpics from './favourite/favourite.epic';
import * as AssetsEpics from './assets/assets.epic';
import * as AttributesEpics from './attributes/attributes.epic';
import * as TransferEpics from './transfer/transfer.epics';
import * as AssetDetailsEpics from './asset-details/asset-details.epics';

import AccountsReducer, {ACCOUNTS_STATE_NAME} from './accounts/accounts.reducer';
import AppReducer, {APP_STATE_NAME} from './app/app.reducer';
import TransferReducer, {TRANSFER_STATE_NAME} from './transfer/transfer.reducer';
import AssetDetailsReducer from './asset-details/asset-details.reducer';
import ReportsReducer, {REPORTS_STATE_NAME} from './reports/reports.reducer';

import {AssetsReducer} from './assets/assets.reducer';
import {SearchReducer} from './search/search.reducer';
import {AttributeReducer} from './attributes/attributes.reducer';
import {TableColumnsReducer} from './table-columns/table-columns.reducer';
import {SecurityGroupsReducer} from './security/security.reducer';
import {FavouriteReducer} from './favourite/favourite.reducer';
import {HistoryReducer} from './history/history.reducer';
import {CurrentUserReducer} from './user/user.reducer';
import {NotificationReducer} from './notification/notification.reducer';

//state roots
import {ROOT_ASSETS_STATE} from './assets/assets.state';
import {ROOT_SEARCH_STATE} from './search/search.state';
import {ROOT_ATTRIBUTES_STATE} from './attributes/attributes.state';
import {ROOT_TABLE_COLUMNS_STATE} from './table-columns/table-columns.state';
import {ROOT_SECURITY_STATE} from './security/security.state';
import {ROOT_FAVOURITES_STATE} from './favourite/favourite.state';
import {ROOT_HISTORY_STATE} from './history/history.state';
import {ROOT_CURRENT_USER_STATE} from './user/user.state';
import {ROOT_NOTIFICATION_STATE} from './notification/notification.state';
import {ASSET_DETAILS_STATE_NAME} from './asset-details/asset-details.state';

const ReducersMap = {};
ReducersMap[APP_STATE_NAME] = AppReducer;
ReducersMap[REPORTS_STATE_NAME] = ReportsReducer;
ReducersMap[ACCOUNTS_STATE_NAME] = AccountsReducer;
ReducersMap[ROOT_ASSETS_STATE] = AssetsReducer;
ReducersMap[ROOT_SEARCH_STATE] = SearchReducer;
ReducersMap[ROOT_ATTRIBUTES_STATE] = AttributeReducer;
ReducersMap[ROOT_TABLE_COLUMNS_STATE] = TableColumnsReducer;
ReducersMap[ROOT_SECURITY_STATE] = SecurityGroupsReducer;
ReducersMap[ROOT_FAVOURITES_STATE] = FavouriteReducer;
ReducersMap[ROOT_HISTORY_STATE] = HistoryReducer;
ReducersMap[ROOT_CURRENT_USER_STATE] = CurrentUserReducer;
ReducersMap[ROOT_NOTIFICATION_STATE] = NotificationReducer;
ReducersMap[TRANSFER_STATE_NAME] = TransferReducer;
ReducersMap[ASSET_DETAILS_STATE_NAME] = AssetDetailsReducer;

const allEpics = [
  AppEpics,
  ReportEpics,
  AccountsEpics,
  AssetsEpics,
  AttributesEpics,
  FavouriteEpics,
  HistoryEpics,
  SearchEpics,
  SecurityEpics,
  TableColumnsEpics,
  UserEpics,
  TransferEpics,
  AssetDetailsEpics
].reduce((accumulator, epics) => {
  return [...accumulator, ...Object.values(epics)];
}, []);

export const RootReducer = combineReducers(ReducersMap);

/**
 *  https://github.com/redux-observable/redux-observable/issues/94#issuecomment-255936172
 *  using function composition
 *  any erroe was not handle in the epic and reach the pipe will caus the epic to be terminated,
 *  so we warping every epic with catch and restart it
 * */
const combineEpicsAndCatchErrors = (...epics) => {
  return (action$, state$) => {
    epics = epics.map(epic => (action$, state$) =>
      epic(action$, state$).pipe(
        catchError((e, source) => {
          // rethrow error so it shows up in the console
          setTimeout(() => {
            throw e;
          }, 0);
          // source is the chain above the catch, so this "retries"
          return source;
        })
      )
    );
    return combineEpics(...epics)(action$, state$);
  };
};

export const RootEpic = combineEpicsAndCatchErrors(...allEpics);
